'use client';

import Image from 'next/image';
import Link from 'next/link';
import { trackEvent } from '@/utils/analytics';

export default function JourneyCta() {
  const handleCtaClick = () => {
    trackEvent({
      action: 'journey_cta_click',
      category: 'cta',
      label: "Let's Go",
      value: 1,
    });
  };

  return (
    <section data-aos="fade-up" className="relative min-h-screen w-full">
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          fill
          priority
          src="/images/a5.jpg"
          className="object-cover"
          alt="mutrah corniche Oman"
          aria-label="mutrah corniche Oman"
        />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen text-center px-4">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 max-w-2xl drop-shadow-lg">
          Let's start a journey
        </h2>
        <Link
          href="/contact"
          className="px-8 py-3 border-2 border-white text-white rounded-full hover:bg-white hover:text-black transition-colors duration-300"
          onClick={handleCtaClick}
        >
          Let's Go
        </Link>
      </div>
    </section>
  );
}
